import Route from '@ember/routing/route';

export default class ManualTimeRoute extends Route 
{
	model() 
	{
		return this.modelFor("event");
	}
}
